<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ reseller.name }} - {{ $t("COMMON.USERS") }}
      </span>
    </div>

    <user-list-table :filterReseller="reseller.id" />
  </div>
</template>

<script>
import UserListTable from "../../UserManagement/partials/UserListTable.vue";
export default {
  name: "reseller-view-users",

  components: { UserListTable },

  props: ["reseller"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    reseller(reseller) {},
  },
};
</script>
